import axios, { AxiosResponse } from 'axios';
import apiUrl from '../../../helpers/apiUrl';
import { message } from 'antd';

export const getSectionsRequest = async (): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/sections`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response: AxiosResponse<{ code: number; message: string }>) => {
      if (response?.data) {
        return response.data;
      }
    });
};

export const saveSectionRequest = async (data: { id: number }): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .put(
      `${apiUrl()}backoffice/sections/${data.id}`,
      {
        data,
      },
      {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(<string>tokenString)?.accessToken
          }`,
        },
      }
    )
    .then(() => {
      message.success('Pozytywnie zapisano');
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

export const getProvincesRequest = async (): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/sections/provinces`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      const { data } = response;
      if (data) {
        return data;
      }
    })
    .catch((e): any => {
      message.error(e.message);
    });
};

export const removeSpecificSectionRequest = async (
  idSection: number
): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .delete(`${apiUrl()}backoffice/sections/${idSection}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .catch((e): any => {
      message.error(e.message);
      return false;
    });
};

export const getSpecificSectionRequest = async (id: string): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .get(`${apiUrl()}backoffice/sections/${id}`, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then((response) => {
      const { data } = response;
      if (data) {
        return data;
      }
    })
    .catch((e) => {
      message.error(e.message);
    });
};

export const createSectionRequest = async (data: any): Promise<any> => {
  const tokenString = localStorage.getItem('token');
  return axios
    .post(`${apiUrl()}backoffice/sections`, data, {
      headers: {
        Authorization: `Bearer ${JSON.parse(<string>tokenString)?.accessToken}`,
      },
    })
    .then(() => {
      message.success('Pozytywnie utworzono region');
    })
    .catch((e): any => {
      message.error(e.message);
    });
};
